import { BFFPageData } from '../../services/serviceClients/BffClient'

export default class PageDataUtil {
  public static getMpv(mpvId: string, pageDataFromBFF: BFFPageData) {
    return pageDataFromBFF.mpvs.find((mpv) => mpv.mpvId === mpvId)
  }

  public static sanitizeLocale(locale: string): string {
    return `${locale.slice(0, 2).toLowerCase()}-${locale.slice(-2).toUpperCase()}`
  }
}
